module.exports = __webpack_public_path__ + "static/media/sweet_5.92738124.png";